<template>
  <div>
    <div class="d-flex justify-space-between align-top sm-gap">
      <div>
        {{ item.nom }}
      </div>
      <div class="text-body font-weight-bold">
        <span v-if="item.current_price">{{ item.current_price }}€</span>
        <span v-else>
          Gratuit
          <span v-if="item.cart?.prix_regulier"
            class="text-caption text-medium-emphasis text-decoration-line-through ml-1">
            {{ item.cart?.prix_regulier }}€
          </span>
        </span>
      </div>
    </div>
    <div class="d-flex flex-row justify-start  sm-gap">
      <v-chip v-for="course in item.list_liaisons" :key="course.id" color="white" size="small" variant="elevated"
        elevation="0" class="spo-border">
        {{ course.nom_course }}
      </v-chip>
    </div>



  </div>
  <!--  <div class="cart_course_item p-2 my-2">
    <div class="d-flex justify-start align-center gap">
      <div class="align-self-start">
        <v-badge :content="item.list_liaisons.length" color="darkblue" inline><v-icon icon="mdi-flag-variant"
            color="primary" size="x-large"></v-icon></v-badge>
      </div>
      <div>
        <div class="text-subtitle-2">Pack de courses</div>
        <div class="text-body-2">{{ item.nom }}</div>
      </div>
      <div class="justify-self-end text-h6">
        <span v-if="item.current_price">{{ item.current_price }}€</span><span v-else>Gratuit</span>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="d-flex justify-start align-center gap" v-for="course in item.list_liaisons" :key="course.id">
      <div class="text-body-2"><v-icon icon="mdi-plus" color="primary" size="x-large"></v-icon> {{ course.nom_course }}
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  props: ["item"],
  computed: {},
};
</script>

<style lang="scss" scoped></style>